class Logo extends React.PureComponent {
  render() {
    const { logoPath } = this.props;

    return (
      <div className="Client-Logo">
        <img src={`${window.Edocat.texts.appContext}${logoPath}`} alt="Client Logo" />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  logoPath: state.login.logoPath,
});

export default reactRedux.connect(mapStateToProps, null)(Logo);
